<template>
  <div v-bind:class="drawer" v-bind:onchange="tamano">
    <barraSuperior></barraSuperior>
    <navegacionLateral></navegacionLateral>
    <component v-bind:is="currentTabComponent()"></component>
    <footerPanel></footerPanel>
  </div>

</template>

<script>
  import barraSuperior from './compartida/barraSuperior';
  import navegacionLateral from './compartida/navegacionLateral';
  import admin from './privada/admin/admin';
  import regularPrincipal from './privada/regular/regularPrincipal';
  import footerPanel from './compartida/footer';
  import servicioApi from './privada/servicioApi';

  export default {
    name: "privada",
    data() {
      return {
        drawer: 'bmd-layout-container bmd-drawer-f-l',
        currentTab: 'admin',
        usuario: {},
        cliente: {},
        categorias: {}
      }
    },
    components: {barraSuperior, navegacionLateral, admin, footerPanel, regularPrincipal},
    created() {
      $(document).ready(function () {
        $('body').bootstrapMaterialDesign();
      });
    },
    beforeCreate() {
      let self = this;
      servicioApi.rol_regular.clientes.getClientes()
        .then(response => {
          self.usuario.id = response.data.data.id;
          self.usuario.nombre = response.data.data.name;
          self.usuario.correo = response.data.data.email;
          self.usuario.rol = response.data.data.rol;
          self.cliente = response.data.data.clientes[0];
          EventBus.$emit('usuario', self.usuario);
          EventBus.$emit('empresa', self.cliente);
        }).catch(e => {
        if (e.response.config.headers.Authorization.length < 400)
          this.$router.go('/panel');
      });
    },
    computed: {
      tamano: function () {
        if (window.innerWidth < 576) {
          this.drawer = 'bmd-layout-container bmd-drawer-f-l bmd-drawer-overlay';
        } else {
          this.drawer = 'bmd-layout-container bmd-drawer-f-l';
        }
        this.$nextTick(() => {
          window.addEventListener('resize', () => {
            if (window.innerWidth < 576) {
              this.$router.go('/panel')
              this.drawer = 'bmd-layout-container bmd-drawer-f-l bmd-drawer-overlay';
            } else {
              this.drawer = 'bmd-layout-container bmd-drawer-f-l';
            }
          });
        })
      }
    },
    methods: {
      currentTabComponent: function () {
        this.currentTab = "regularPrincipal";
        return this.currentTab;
      }
    }
  }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/panel.vue